import React, { Component } from "react";
import "./marshalDetailsMweb.scss";

class MarshalDetailsMweb extends Component {
  handleDial = (mobileNo) => {
    window.location.href = `tel:${mobileNo}`;
  };

  render() {
    const { connectingMarshal, index, isTrackBusLoading } = this.props;

    return (
      <div className="marshalDetails">
        {connectingMarshal &&
        connectingMarshal.name &&
        connectingMarshal.mobileNo ? (
          <>
            <div className="title">{`Marshal ${index + 1}`}</div>
            <div className="detailRow">
              <img
                className="detailIcon"
                src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/person1.svg"
                alt="marshal name"
              />
              <span className="detailLabel">Name:</span>
              <span className="detailValue">{connectingMarshal.name}</span>
            </div>
            <div className="detailRow">
              <img
                className="detailIcon"
                src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/callicon.svg"
                alt="call marshal"
              />
              <span className="detailLabel">Mobile:</span>
              <span className="detailValue">{connectingMarshal.mobileNo}</span>
            </div>
              <button
                className="callButton"
                onClick={() => this.handleDial(connectingMarshal.mobileNo)}
              >
                Call Marshal
              </button>

          </>
        ) : (
          <div className="title">Marshal Details Unavailable</div>
        )}
      </div>
    );
  }
}

export default MarshalDetailsMweb;
